/* eslint-disable default-case */
/* eslint-disable import/prefer-default-export */
/*
 *  Copyright (c) 2015 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


import Call from './call';

function NetworkTest(test, protocol, params, iceCandidateFilter) {
  this.test = test;
  this.protocol = protocol;
  this.params = params;
  this.iceCandidateFilter = iceCandidateFilter;
}

NetworkTest.prototype = {
  run() {
    // Do not create turn config for IPV6 test.
    if (this.iceCandidateFilter.toString() === Call.isIpv6.toString()) {
      this.gatherCandidates(null, this.params, this.iceCandidateFilter);
    } else if (this.test.server === 'TURN') {
      Call.asyncCreateTurnConfig(
        this.start.bind(this),
        this.test.reportFatal.bind(this.test), this.test.region,
      );
    } else {
      Call.asyncCreateStunConfig(
        this.start.bind(this),
        this.test.reportFatal.bind(this.test), this.test.region,
      );
    }
  },

  start(config) {
    this.filterConfig(config, this.protocol);
    this.gatherCandidates(config, this.params, this.iceCandidateFilter);
  },

  // Filter the RTCConfiguration |config| to only contain URLs with the
  // specified transport protocol |protocol|. If no turn transport is
  // specified it is added with the requested protocol.
  filterConfig(config, protocol) {
    const newIceServers = [];
    const iceServer = config.iceServers[0];
    const new_urls = [];
    const transport = `transport=${protocol}`;
    const uri = (iceServer.urls.startsWith('turns')) ? `${iceServer.urls}?${transport}` : iceServer.urls;
    new_urls.push(uri);
    iceServer.urls = new_urls;
    newIceServers.push(iceServer);
    config.iceServers = newIceServers;
  },

  // Create a PeerConnection, and gather candidates using RTCConfig |config|
  // and ctor params |params|. Succeed if any candidates pass the |isGood|
  // check, fail if we complete gathering without any passing.
  gatherCandidates(config, params, isGood) {
    let pc;
    try {
      pc = new RTCPeerConnection(config, params);
    } catch (error) {
      if (params !== null && params.optional[0].googIPv6) {
        this.test.reportError('Failed to create peer connection, IPv6 ' +
            'might not be setup/supported on the network.');
      } else {
        this.test.reportError(`Failed to create peer connection: ${error}`);
      }
      this.test.done();
      return;
    }

    // In our candidate callback, stop if we get a candidate that passes
    // |isGood|.
    pc.addEventListener('icecandidate', (e) => {
      // Once we've decided, ignore future callbacks.
      if (e.currentTarget.signalingState === 'closed') {
        return;
      }

      if (e.candidate) {
        const parsed = Call.parseCandidate(e.candidate.candidate);
        if (isGood(parsed)) {
          this.test.reportSuccess(`Gathered candidate of Type: ${parsed.type
              } Protocol: ${parsed.protocol} Address: ${parsed.address}`);
          pc.close();
          pc = null;
          this.test.done();
        }
      } else {
        pc.close();
        pc = null;
        if (params !== null && params.optional[0].googIPv6) {
          this.test.reportError('Failed to gather IPv6 candidates, it ' +
              'might not be setup/supported on the network.');
        } else {
          this.test.reportError('Failed to gather specified candidates');
        }
        this.test.done();
      }
    });

    this.createAudioOnlyReceiveOffer(pc);
  },

  // Create an audio-only, recvonly offer, and setLD with it.
  // This will trigger candidate gathering.
  createAudioOnlyReceiveOffer(pc) {
    const createOfferParams = { offerToReceiveAudio: 1 };
    pc.createOffer(createOfferParams).then(
        (offer) => {
          pc.setLocalDescription(offer).then(
              noop,
              noop,
          );
        },
        noop,
    );

    // Empty function for callbacks requiring a function.
    function noop() {}
  },
};

export function testNetwork(test) {
  //this.region = 'IN';
  //this.server = 'TURN';
  switch (test.test_title) {
    case 'udp_enabled':
    {
      // Test whether it can connect via UDP to a TURN server
      // Get a TURN config, and try to get a relay candidate using UDP.
      const networkTest = new NetworkTest(test, 'udp', null, Call.isRelay);
      networkTest.run();
      break;
    }
    case 'tcp_enabled':
    {
      // Test whether it can connect via TCP to a TURN server
      // Get a TURN config, and try to get a relay candidate using TCP.
      const networkTest = new NetworkTest(test, 'tcp', null, Call.isRelay);
      networkTest.run();
      break;
    }
    case 'ipv6_enabled':
    {
      // Test whether it is IPv6 enabled (TODO: test IPv6 to a destination).
      // Turn on IPv6, and try to get an IPv6 host candidate.
      const params = { optional: [{ googIPv6: true }] };
      const networkTest = new NetworkTest(test, null, params, Call.isIpv6);
      networkTest.run();
      break;
    }
  }
}




//////////////////
// WEBPACK FOOTER
// ./src/testWebRtc/nettest.js
// module id = 209
// module chunks = 0